// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"d8bc0c19","70":"873eff9b","298":"3d6fea55","546":"5999a150","669":"15a3ebc1","787":"1199a6d1"}[chunkId] + ".chunk.js";
};